<template>
    <TotemSelect
        :options="languages"
        @input="setSelectedLanguage"
        class="select-language"
        :value="getSelectedLanguage"
        :clearable="false"
        :width="160"
        :theme="theme"
        languageSelector
    >
    </TotemSelect>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { userMetadataKeys } from 'services/yggdrasil/setter'
    export default {
        name: 'select-language',
        inject: ['headerTheme'],
        computed: {
            ...mapGetters({
                languages: 'Languages/getLanguages',
                selectedCountryCode: 'Languages/getSelectedCountryCode'
            }),
            getSelectedLanguage () {
                return this.languages.find(language => language.countryCode === this.selectedCountryCode)
            },
            theme () {
                return this.headerTheme()
            },
        },
        methods: {
            async setSelectedLanguage (language) {
                await this.$store.dispatch('Languages/setSelectedLanguage', language.countryCode)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .select-language {
        [class*="desktop_xx"] & {
            min-width: 165px;
        }
    }
</style>
